import React, { useState } from "react";
import {
  CreateHallFloorPayload,
  Hall,
  HallFloor,
  UpdateHallPayload,
} from "../../interfaces";
import {
  Button,
  Form,
  Popconfirm,
  Row,
  Space,
  Table,
  TableProps,
  Tag,
} from "antd";
import UpdateHallForm from "./UpdateHallForm";
import { useForm } from "antd/lib/form/Form";
import { appSelector } from "../../helpers/appSelector";
import { deleteHall, getHalls, updateHall } from "../../store/halls";
import { useDispatch } from "react-redux";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import CreateHallFloorForm from "../hallsFloors/CreateHallFloorForm";
import { createHallFloor } from "../../store/hallFloors";

interface Props {
  halls: Hall[];
  loading: boolean;
}

const HallsList = ({ halls, loading }: Props) => {
  const [hallId, setHallId] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const { school, success } = appSelector((state) => state.schoolStore);
  // const { halls: mainHalls } = appSelector((state) => state.hallsStore);
  const { isHallDeleting, deleteSuccess } = appSelector(
    (state) => state.hallsStore
  );

  const [deletableId, setDeletableId] = useState<string | null>(null);
  const [openAddFloorModal, setOpenAddFloorModal] = useState<boolean>(false);

  const handleOnFinish = (values: UpdateHallPayload) => {
    values.school_id = school?.id?.toString() || "";
    values.id = hallId;
    dispatch(updateHall(values));
    if (success) {
      setOpen(false);
    }
  };

  const handleDelete = (id: string) => {
    dispatch(deleteHall(id));
    isHallDeleting && setDeletableId(id);
    deleteSuccess && setDeletableId(null);
  };

  const handleOnFinishCreateHallFloor = (values: CreateHallFloorPayload) => {
    values.hall_id = hallId.toString() || "";
    dispatch(createHallFloor(values));
    setOpenAddFloorModal(false);
    dispatch(getHalls(school?.id as string));
    // halls = halls.map((hall) => {
    //   if (hall.id === hallId) {
    //     const newFloor: HallFloor = {
    //       ...values,
    //       id: new Date().toISOString(),
    //       prefects: null,
    //     };
    //     hall.floors = hall.floors ? [...hall.floors, newFloor] : [newFloor];
    //   }
    //   return hall;
    // });
  };

  const createHallFloorInitialValues: CreateHallFloorPayload = {
    name: "",
    description: "",
    hall_id: hallId,
  };

  const columns: TableProps<Hall>["columns"] = [
    {
      title: "Hall Name",
      dataIndex: "name",
      align: "left",
      key: "hall",
      sorter: (a: Hall, b: Hall) => a.name.localeCompare(b.name),
    },
    {
      title: "Contact",
      dataIndex: "contact",
      align: "left",
      key: "contact",
      sorter: (a: Hall, b: Hall) =>
        (a.contact?.length || 0) - (b.contact?.length || 0),
    },
    {
      title: "Floors",
      align: "left",
      key: "blocks",
      render: (record: Hall) => (
        <Row justify="space-between">
          <Tag color="processing" key="floor-count">
            {record.floors?.length}
          </Tag>

          <Button
            size="small"
            icon={<PlusOutlined />}
            onClick={() => {
              setHallId(record.id);
              setOpenAddFloorModal(true);
            }}
          ></Button>
        </Row>
      ),
    },
    {
      title: "Rooms",
      align: "left",
      key: "rooms",
      render: (record: Hall) => (
        <Tag color="success" key="room-count">
          {record.rooms?.length}
        </Tag>
      ),
    },
    // {
    //   title: "Total Beds",
    //   dataIndex: "total_beds",
    //   align: "center",
    //   key: "total",
    //   sorter: (a: any, b: any) => a.id - b.id,
    // },
    // {
    //   title: "Available Beds",
    //   dataIndex: "available_beds",
    //   align: "center",
    //   key: "available",
    //   sorter: (a: any, b: any) => a.id - b.id,
    // },
    // {
    //   title: "Occupied Beds",
    //   dataIndex: "occupied_beds",
    //   align: "center",
    //   key: "occupied",
    //   sorter: (a: any, b: any) => a.id - b.id,
    // },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (record: Hall) => (
        <Space size="middle">
          <Button
            key={`edit-${record.id}`}
            type="primary"
            onClick={() => {
              setHallId(record.id);
              setOpen(true);
            }}
          >
            Edit
          </Button>
          <Popconfirm
            placement="topLeft"
            title="Are you sure you want to delete this hall?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              key={`delete-${record.id}`}
              danger
              icon={<DeleteOutlined />}
              loading={deletableId == record.id}
            >
              {deletableId == record.id ? "Deleting..." : "Delete"}
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table<Hall>
        size="small"
        columns={columns}
        dataSource={halls}
        loading={loading}
        scroll={{ x: true }}
      />

      <UpdateHallForm
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        form={form}
        onFinish={handleOnFinish}
        id={hallId}
        schoolId={school?.id}
      />

      <CreateHallFloorForm
        open={openAddFloorModal}
        onCancel={() => setOpenAddFloorModal(false)}
        loading={false}
        form={form}
        initialValues={createHallFloorInitialValues}
        onFinish={handleOnFinishCreateHallFloor}
      />
    </>
  );
};

export default HallsList;
